import { render, staticRenderFns } from "./identificadores.vue?vue&type=template&id=3aad57a0"
import script from "./identificadores.vue?vue&type=script&lang=js"
export * from "./identificadores.vue?vue&type=script&lang=js"
import style0 from "./identificadores.vue?vue&type=style&index=0&id=3aad57a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports